import React from "react";
import EntityList from "../EntityList/EntityList";

class QuestionnairesList extends React.Component {
  constructor(props, context) {
    super(props, context);
    //Entities are copied to the state because they can change?
    // but if entities come from the parent shouldn't I change it there?
    // what will I do after an update in the list?
    // the easiest would be to just request the list once again
    // and fetch the updates
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle = ({ event, field, entity }) => {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    console.log("toggled ");
    console.log(field);
    console.log(entity);
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
    });
  };
  handleDelete = ({ event, entity }) => {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();

    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  };

  render() {
    const { config } = this.props;
    const { name, entityName, validation, fields, renderers, reorder } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    const { handleToggle, handleDelete } = this;
    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        success={success}
        reorder={reorder}
        onReorder={this.props.onReorderListItem}
      />
    );
  }
}

QuestionnairesList.propTypes = {};

QuestionnairesList.defaultProps = {
  entities: [],
};

export default QuestionnairesList;
